module.exports = __webpack_public_path__ + "static/img/orange-m.6d022cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/orange-m.jpg
// module id = VxFN
// module chunks = 0